import { render } from "./WhoAreYou.vue?vue&type=template&id=98f8bc0e"
import script from "./WhoAreYou.vue?vue&type=script&lang=js"
export * from "./WhoAreYou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__